import { IconProps } from "./types";
import { SVGIcon } from "./svg-icon";

export const Sent = ({
  size,
  type,
  theme,
  className,
  dataTestId = "sent",
}: IconProps) => (
  <SVGIcon
    size={size}
    type={type}
    theme={theme}
    className={className}
    dataTestId={dataTestId}
  >
    <path d="M8.067 5.865a.667.667 0 0 1 .942-.003l2.017 2.006a.664.664 0 0 1-.003.947l-2.03 2.006a.667.667 0 1 1-.936-.947l.876-.865h-3.49a.667.667 0 0 1 0-1.334h3.496l-.872-.867a.667.667 0 0 1 0-.943Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.822 1.555C1.822.82 2.42.222 3.156.222h6.362c.354 0 .693.14.943.39l3.33 3.33c.25.25.39.59.39.943v9.56c0 .736-.596 1.333-1.333 1.333H3.156a1.333 1.333 0 0 1-1.334-1.333V1.555Zm7.696 0H3.156v12.89h9.692v-9.56l-3.33-3.33Z"
    />
  </SVGIcon>
);
